<!--
    描述：编辑树弹窗内容
    时间：2020-05-19
    Created by ws
-->
<template>
	<div class="h100">
		<el-tree
			:data="treeData"
			node-key="treeId"
			ref="tree"
			class="custom-tree"
			draggable
			:allow-drag="allowDrag"
			:allow-drop="allowDrop"
			@node-drop="handleDrop"
			@node-drag-start="handleDragStart"
			@node-drag-end="handleDragEnd"
			default-expand-all
			:expand-on-click-node="false"
		>
			<div class="custom-row" slot-scope="{ node, data }">
				<!-- <template v-if="node.level === 1">
          <el-input type="text" size="small" class="is-required-item" disabled v-model="data.sname"></el-input>
        </template>
        <template v-else> -->
				<span class="sname-width" :class="{ pdr0: data.levelType === 0 }">
					<el-input
						type="text"
						size="small"
						class="is-required-item"
						:disabled="node.level < 2 || data.isSpe === 1"
						placeholder="请输入内容"
						v-model="data.sname"
						maxlength="100"
						show-word-limit
					>
					</el-input>
					<!-- <span class="vxe-cell--label" v-else>{{ data.sname }}</span> -->
				</span>
				<span class="type-width" v-if="data.levelType !== 0">{{ data.levelType === 1 ? '单项工程类型：' : '单位工程类型：' }}</span>
				<span class="code-width" v-if="data.levelType !== 0">
					<!-- 单项工程 -->
					<el-select class="is-required-item" size="small" v-model="data.levelTypeCode" v-if="data.levelType === 1">
						<el-option v-for="(item, index) in singleList" :key="'单项' + index" :label="item.sname" :value="item.value"></el-option>
					</el-select>
					<!-- 单位工程 -->
					<el-select class="is-required-item" size="small" v-model="data.levelTypeCode" v-if="data.levelType === 2">
						<el-option v-for="(item, index) in unitList" :key="'单位' + index" :label="item.sname" :value="item.value"></el-option>
					</el-select>
				</span>
				<span class="query-width" v-if="data.levelType !== 0">
					<!-- 单项工程 -->
					<template v-if="data.levelType === 1" class="flex">
						是否可查询：
						<el-select class="is-required-item" size="small" v-model="data.isQuery">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="0"></el-option>
						</el-select>
					</template>
				</span>
				<span class="tool-width">
					<el-button type="text" size="mini" icon="el-icon-plus" :disabled="data.levelType === 2" @click="handleNode('append', node, data)">
					</el-button>
					<el-button
						type="text"
						size="mini"
						icon="el-icon-minus"
						:disabled="(data.children && data.children.length > 0) || data.isSpe === 1"
						@click="handleNode('remove', node, data)"
					>
					</el-button>
					<el-button
						type="text"
						size="mini"
						icon="el-icon-rank"
						:disabled="node.data.isSpe === 1 || node.parent.data.isSpe === 1 || node.level === 1 || node.parent.childNodes.length === 1"
					>
					</el-button>
				</span>
				<!-- </template> -->
			</div>
			<!-- <span class="custom-tree-node" slot-scope="{ node, data }">
          <el-input type="text" class="tree-input" size="small" ref="input" v-model="data.sname" :disabled="node.level<2"></el-input>
          <span class="typeName text-overflow" v-if="node.level === 2" :title="data.levelTypeName">单项工程类型: {{ data.levelTypeName }}</span>
          <span class="typeName text-overflow" v-if="node.level === 3" :title="data.levelTypeName">单位工程类型: {{ data.levelTypeName }}</span>
          <span class="btn-span">
              <el-button type="text" size="mini" v-if="node.level < 3" @click="() => append(data)">
                  <i class="el-icon-plus"></i>
              </el-button>
              <el-button type="text" size="mini" v-if="node.level > 2" @click="() => remove(node,data)">
                  <i class="el-icon-delete"></i>
              </el-button>
              <el-button type="text" size="mini" :disabled="node.parent.childNodes.length === 1" v-if="node.level > 1">
                  <i class="el-icon-rank"></i>
              </el-button>
          </span>
      </span> -->
		</el-tree>
		<!-- 新增弹窗 -->
		<el-dialog
			:title="dialogObj.title"
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:close-on-click-modal="false"
			append-to-body
			@closed="handleClose"
		>
			<div class="h100">
				<!-- 树主体 -->
				<div v-if="addType === 1">
					<el-form
						label-width="120px"
						ref="addForm"
						:model="addList[0]"
						:rules="addLevelRules"
						v-for="(item, index) in addList"
						:key="'addList' + index"
					>
						<el-row>
							<el-col :span="12">
								<el-form-item label="单项工程名称" prop="sname">
									<el-input v-model="item.sname" placeholder="请输入单项工程名称"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="单项工程类型" prop="levelTypeCode">
									<el-select v-model="item.levelTypeCode" placeholder="请选择">
										<el-option v-for="(item, index) in singleList" :key="'类型' + index" :label="item.sname" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="单位工程名称" prop="children[0].sname">
									<el-input v-model="item.children[0].sname" placeholder="请输入单位工程名称"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="单位工程类型" prop="children[0].codeArr">
									<el-select
										v-model="item.children[0].codeArr"
										placeholder="请选择"
										multiple
										collapse-tags
										@change="handleChange($event, item.children[0])"
									>
										<el-option v-for="(item, index) in unitList" :key="'类型' + index" :label="item.sname" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<div v-else>
					<el-form
						label-width="120px"
						ref="addForm"
						:model="addList[0]"
						:rules="addRules"
						v-for="(item, index) in addList"
						:key="'addList' + index"
					>
						<el-row>
							<el-col :span="12">
								<el-form-item label="单位工程名称" prop="sname">
									<el-input v-model="item.sname" placeholder="请输入单位工程名称"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="单位工程类型" prop="codeArr">
									<el-select
										v-model="item.codeArr"
										placeholder="请选择"
										multiple
										collapse-tags
										@change="handleChange($event, item)"
									>
										<el-option v-for="(item, index) in unitList" :key="'类型' + index" :label="item.sname" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="dialog-footer text-center">
				<el-button @click="onCancel" size="small">取 消</el-button>
				<el-button type="primary" size="small" :loading="btnLoading" @click="addSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getStructureData, addTreeNode, delTreeNode, saveAndeditProjectTree } from '@/api/modules/dataProject.js'

export default {
	props: {
		// 外面的表格数据
		existData: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	data() {
		return {
			treeData: [],
			// 弹窗信息对象
			dialogObj: {
				title: '新增节点',
				visible: false,
				width: '650px',
				type: ''
			},
			btnLoading: false,
			addList: [],
			addType: 0,
			// 单位工程 rules
			addRules: {
				sname: [
					{
						required: true,
						message: '请输入工程名称',
						trigger: 'blur'
					}
				],
				codeArr: [
					{
						required: true,
						type: 'array',
						message: '请选择工程类型',
						trigger: 'change'
					}
				]
			},
			// 单项工程 rules
			addLevelRules: {
				sname: [
					{
						required: true,
						message: '请输入单项工程名称',
						trigger: 'blur'
					}
				],
				levelTypeCode: [
					{
						required: true,
						message: '请选择单项工程类型',
						trigger: 'change'
					}
				],
				'children[0].sname': [
					{
						required: true,
						message: '请输入单位工程名称',
						trigger: 'blur'
					}
				],
				'children[0].codeArr': [
					{
						required: true,
						type: 'array',
						message: '请选择单位工程类型',
						trigger: 'change'
					}
				]
			},
			// 是否允许拖拽
			activeDrag: true,
			currentTreeData: []
		}
	},
	created() {
		this.treeData = []
		let arr = JSON.parse(JSON.stringify(this.existData))
		this.treeData.push(arr[0])
	},
	methods: {
		// 添加、删除节点
		async handleNode(type, node, data) {
			switch (type) {
				// 添加节点
				case 'append':
					let add_node = {
						sname: '',
						treeId: data.treeId + (data.children.length + 1),
						pid: data.treeId, // 父节点id
						projectId: this.curProjectId,
						aid: this.curProjectId,
						levelType: data.levelType === 0 ? 1 : 2,
						levelTypeCode: '',
						isQuery: 0,
						children: []
					}

					// 添加单项时自带单位
					if (data.levelType === 0) {
						add_node.children.push({
							sname: '',
							treeId: add_node.treeId + 1,
							pid: add_node.treeId,
							projectId: this.curProjectId,
							aid: this.curProjectId,
							levelType: 2,
							levelTypeCode: '',
							children: []
						})
					}
					// node._expand = true;
					node.expanded = true
					data.children.unshift(add_node)

					// 设置选中
					setTimeout(() => {
						this.$refs.tree.setCurrentKey(add_node.treeId)
					}, 500)
					break
				// 移除节点
				case 'remove':
					// debugger

					// 找到父节点
					let _parent = this.$utils.findTree(this.treeData, (x) => x.treeId === data.pid).item

					// 如果是新增的 没有id
					if (!data.id) {
						this.deleteMethod(_parent, data)
						return
					}

					// 已经存在的 接口删除
					this.$confirm('确认要删除当前数据吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							delTreeNode({ id: data.id }).then((res) => {
								this.deleteMethod(_parent, data)
							})
						})
						.catch(() => {})
			}
		},

		// 删除公共函数（有 id 和 没id）
		deleteMethod(_parent, row) {
			if (_parent) {
				// 删除节点
				_parent.children.splice(
					_parent.children.findIndex((x) => x.treeId === row.treeId),
					1
				)

				// 如果父节点下面没有子节点了(单项工程)  也删除父节点
				if (_parent.children.length === 0 && _parent.levelType === 1 && _parent.isSpe !== 1) {
					let root = this.treeData[0]
					root.children.splice(
						root.children.findIndex((x) => x.treeId === _parent.treeId),
						1
					)
				}
			}
		},

		// 新增节点
		append(data) {
			let params = {}
			if (data.levelType === 0) {
				this.addType = 1
				params = {
					aid: this.curProjectId,
					sname: '',
					levelTypeCode: '',
					levelType: 2,
					isQuery: 0,
					children: [
						{
							sname: '',
							codeArr: [],
							levelTypeCode: '',
							levelType: 3,
							aid: this.curProjectId
						}
					]
				}
			} else {
				this.addType = 2
				params = {
					sname: '',
					pid: data.id,
					levelTypeCode: '',
					codeArr: [],
					levelType: 3,
					aid: this.curProjectId
				}
			}
			this.addList.push(params)
			this.dialogObj.visible = true
			this.dialogObj.type = 'add'
		},

		// 移除节点
		remove(node, data) {
			this.$confirm('确认要删除当前数据吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					delTreeNode({ id: data.id }).then((res) => {
						this.reloadTable()
					})
				})
				.catch(() => {})
		},

		// 刷新数据
		reloadTable() {
			// 先清空
			this.treeData = []
			// 请求数据
			getStructureData({ id: this.curProjectId })
				.then((res) => {
					this.treeData.push(res.data)
				})
				.catch((err) => {})
		},

		// 关闭弹窗的事件
		handleClose() {
			this.dialogObj.visible = false
			this.dialogObj.type = ''
			this.addList = []
			this.btnLoading = false
		},

		// 切换单位工程类型
		handleChange(selectedArr, obj) {
			obj.levelTypeCode = selectedArr.join(',')
		},

		// 确认新增
		addSubmit() {
			this.btnLoading = true
			let arr = JSON.parse(JSON.stringify(this.addList))

			this.$refs.addForm[0].validate((valid) => {
				if (valid) {
					addTreeNode({ children: arr })
						.then((res) => {
							this.btnLoading = false
							if (res.operationCode === 1) {
								this.onCancel()
								this.reloadTable()
							}
						})
						.catch((err) => {
							this.btnLoading = false
						})
				} else {
					setTimeout(() => {
						this.btnLoading = false
					}, 3000)
					return false
				}
			})
		},

		// 取消新增节点弹窗
		onCancel() {
			this.dialogObj.visible = false
			this.addType = 0
		},

		// allowDrag
		allowDrag(draggingNode) {
			return draggingNode.parent.childNodes.length > 1 && draggingNode.parent.data.isSpe !== 1 && draggingNode.data.isSpe !== 1
		},

		// 判断是否能拖拽节点 --- 放入
		allowDrop(draggingNode, dropNode, type) {
			// 如果是 二级 目标是签证 放到 前面
			if (dropNode.data.isSpe === 1 && draggingNode.level === 2) {
				return type === 'prev'
			}

			// 如果是 三级 目标是二级 放到 里面
			if (dropNode.level === 2 && draggingNode.level === 3) {
				return type === 'inner'
			}

			// 如果目标是三级
			if (dropNode.level === 3) {
				return type !== 'inner'
			}

			// 或者是最顶级
			if (dropNode.level === 1) {
				return false
			}

			// 如果是 2级结构互拖拽  只改变顺序
			if (draggingNode.level === 2 && dropNode.level === 2) {
				return type !== 'inner'
			}

			return true
		},

		// 拖拽开始
		handleDragStart() {
			this.currentTreeData = JSON.parse(JSON.stringify(this.treeData))
		},

		// 拖拽结束
		handleDragEnd(node, targetNode) {
			// console.log(node)
			// console.log(targetNode)
			if (!targetNode) {
				this.$message.warning('不能放到该位置！')
				return
			}

			// 如果 当前是 第二级，有children 不可放入第三级
			if (node.level === 2 && node.childNodes.length > 0 && targetNode.level === 3) {
				this.$message.warning('项目结构最多只有三个层级！')
				this.treeData = JSON.parse(JSON.stringify(this.currentTreeData))
			}

			// 单位工程不能 变成单项工程
			// if (node.level === 3 && targetNode.level === 2) {
			//     this.$message.warning('单位工程只能放到单项工程下！')
			//     this.treeData = JSON.parse(JSON.stringify(this.currentTreeData))
			// }
		},

		// 节点拖拽完毕事件
		handleDrop(node, otherNode) {
			// 拖拽完毕  修改节点pid 以及 对应的 type 层级
			node.data.pid = otherNode.data.pid
			node.data.levelType = otherNode.data.levelType
		},

		// 重新排序
		sortData(list) {
			if (list && list.length > 0) {
				list.map((item, index) => {
					item.sort = index

					// 递归
					this.sortData(item.children)
				})
			}
		},

		// 确定保存
		doSave() {
			let params = JSON.parse(JSON.stringify(this.treeData))
			//下面这个操作就是具体定位到那一处的填写有问题
			let requireSname = ''
			this.treeData.forEach((x) => {
				if (x.sname === '' || x.levelTypeCode === '' || !x.levelTypeCode) {
					if (x.sname === '') {
						requireSname = '项目名称有缺失！！'
						return
					}
					requireSname = '项目名称' + x.sname + '的工程类型缺失！！'
					return
				}
				if (x.children.length > 0) {
					x.children.forEach((y) => {
						if (y.sname === '' || y.levelTypeCode === '' || !y.levelTypeCode) {
							if (y.sname === '') {
								requireSname = x.sname + '下的单项工程名称有缺失！！'
								return
							}
							if (y.isQuery != 1 && y.isQuery != 0) {
								requireSname = x.sname + '下的是否可查询字段需配置！！'
								return
							}
							requireSname = x.sname + '下的单项工程名称' + y.sname + '的单项工程类型未选择！！'
							return
						}
						if (y.children.length > 0) {
							y.children.forEach((h) => {
								if (h.sname === '' || h.levelTypeCode === '' || !h.levelTypeCode) {
									if (h.sname === '') {
										requireSname = y.sname + '下的单位工程名称有缺失！！'
										return
									}
									requireSname = '单项工程名称' + y.sname + '下的单位工程名称' + h.sname + '的单位工程类型未选择！！'
									return
								}
							})
						}
					})
				}
			})
			// let requireSname = this.$utils.filterTree(this.treeData, x => x.sname === '' || x.levelTypeCode === '' || !x.levelTypeCode)

			if (requireSname.length > 0) {
				this.$message.warning(requireSname)
				this.$emit('onDefault')
				return
			}

			// 重新排序
			this.sortData(params)

			if (params[0].children.length > 0) {
				saveAndeditProjectTree({ children: params[0].children })
					.then((res) => {
						// console.log(res)
						if (res.operationCode === 1) {
							this.$emit('onSuccess')
						} else {
							this.$emit('onDefault')
						}
					})
					.catch((err) => {
						this.$emit('onDefault')
					})
			} else {
				setTimeout(() => {
					this.$emit('onCancel')
				}, 3000)
				this.$message.warning('当前没有要保存的数据!')
			}
		}
	},
	computed: {
		...mapState('dict', {
			singleList: (state) => state.dxgclx,
			unitList: (state) => state.dwgclx
		}),
		// 当前的 项目Id
		curProjectId() {
			return this.$route.query.projectId
		}
	}
}
</script>
<style scoped lang="less">
/deep/ .custom-tree {
	.custom-tree-node {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;

		.tree-input {
			margin-right: 0;
			flex: 1;
		}

		.btn-span {
			display: flex;
			justify-content: flex-end;
			width: 30px;
		}

		.typeName {
			color: #666;
			width: 190px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: default;
			height: 34px;
			line-height: 34px;
		}
	}

	.el-tree-node__content {
		height: 40px;
	}

	.el-input__inner {
		height: 35px;
		line-height: 35px;
	}
}

.custom-row {
	display: flex;
	width: 100%;
	color: #202020;
	align-items: center;

	.sname-width {
		min-width: 300px;
		flex: 1;
		padding: 0 10px;
	}

	.type-width {
		width: 115px;
		text-align: center;
		padding: 0 10px;
	}

	.code-width {
		width: 180px;
		text-align: center;
		// padding: 0 10px;
	}

	.query-width {
		width: 180px;
		display: flex;
		align-items: center;
		padding-left: 10px;
	}

	.tool-width {
		width: 95px;
		text-align: right;
		padding: 0 5px;
	}
}
</style>
